import bowser from 'bowser';

const getDeviceType = () => {
  const parser = bowser.getParser(window.navigator.userAgent);
  const browser = parser.getBrowserName();
  const os = parser.getOSName();

  return `${browser} on ${os}`;
};

export default getDeviceType;
